import { MutableRefObject, useRef } from 'react'

export const useLazyRef = <T>(fn: () => T): MutableRefObject<T> => {
  const value = useRef<T>()

  if (!value.current) {
    value.current = fn()
  }

  return value as MutableRefObject<T>
}
